import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { DistributorListQuery, DistributorRoot } from './types'

export const fetchDistributorList = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: DistributorListQuery }) => {
  return wretchClient
    .url('/admin/1.0/distributors')
    .signal(params?.abortCtrl)
    .query(params?.query || {})
    .get()
    .json<ListingResponse<DistributorRoot>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
